import { render, staticRenderFns } from "./control-left-car.vue?vue&type=template&id=023d6afe&"
import script from "./control-left-car.vue?vue&type=script&lang=js&"
export * from "./control-left-car.vue?vue&type=script&lang=js&"
import style0 from "./control-left-car.vue?vue&type=style&index=0&id=023d6afe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports